import React from 'react';
import PopUp from './popUp';

interface ErrorPopupProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ isOpen, onClose, message }) => {
  return (
    <PopUp
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      title="Error"
      message={message}
      cancelText="Close"
      confirmText="Try Again"
    />
  );
};

export default ErrorPopup; 